<template>
    <base-custom-settings :form-data="formData" save-message="Het startpunt van de flow is aangepast">
        <template #description>
            <text-heading sub>
                Automatische triggering
            </text-heading>
            <text-description :color="'white'">
                Voor deze specifieke flow zijn er geen gebruikersinstellingen
                beschikbaar of noodzakelijk. Dit betekent dat zodra de relevante
                e-mails ontvangen worden, de mailparser onmiddellijk in werking
                treedt zonder dat verdere configuratie vereist is.
            </text-description>
        </template>
    </base-custom-settings>
</template>

<script setup lang="ts">
    import type { Node, Trigger } from '@keyvue/one-api-client';
    import { reactive } from 'vue';
    import BaseCustomSettings from '@/flow/flow/components/graph/custom-types/CustomSettings.vue';
    import { TextDescription, TextHeading } from '@keyvue/one-ui';

    interface NodeOptions {}

    interface Props {
        node: Trigger | Node
    }

    defineProps<Props>();
    const formData = reactive({} as NodeOptions);
</script>
